<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
    name: 'inserat',
    created() {
      this.$store.dispatch('TINY_OBJECTS');
    }
}
</script>
